<template>
  <div class="async-task-card animate__animated"
    :class="{ 'new': isNew, 'processing': isProcessing, 'done': isDone, 'error': isError, 'waiting': isWaiting, 'canceled': isCanceled, 'animate__fadeOutRight': hide }"
    v-if="getTaskId > 0">
    <div class="async-task-card__header">
      <span class="async-task-card__property-type small badge badge-primary" :class="[ task.type === 'INTEGRATION' ? 'badge-secondary' : '']">
        {{ getTaskTypeTranslated }}
      </span>
      <span v-if="canRemoveTask"
        class="async-task-card__close"
        title="Borrar notificación"
        @click="hideTask"
      >
        <i class="fal fa-times"></i>
      </span>
    </div>
    <span class="async-task-card__id text-muted">ID: {{ getTaskId }}</span>
    <div class="card__name-and-actions">
      <div
        v-show="!showCancelConfirmation"
        class="async-task-card__details"
      >
        <p v-if="task.type === 'DATAFEED'" class="async-task-card__template property-value" :title="getTaskTemplate">{{ getTaskTemplate }}</p>
        <p v-if="task.type === 'INTEGRATION'" class="async-task-card__template property-value">{{ task.name }}</p>
        <p class="async-task-card__creation text-muted" :title="`Fecha de creación: ${getTaskCreationDate}`"><i class="fal fa-calendar-day"></i> {{ getTaskCreationDate }}</p>
        <i class="fal fa-info-circle async-task-card__extras" title="Más detalles" @click="showExtraDetails = !showExtraDetails"></i>
        <p v-if="isIntegrationCount"> Se integraron correctamente {{ task.process.successful }} de {{ task.process.total }}.</p>
      </div>
      <button
        v-show="canCancelTask && !showCancelConfirmation"
        class="async-task-card__cancel-btn btn"
        title="Cancelar tarea"
        @click="showCancelTaskConfirmation">
        <i class="fas fa-minus-octagon"></i>
      </button>
      <div
        v-show="showCancelConfirmation"
        class="async-task-card__confirm-deletion"
      >
        <div class="async-task-card__cancel-confirmation">
          <p class="task-card__cancel-question">
            ¿Estás seguro de cancelar está tarea: <span>"{{ getTaskTemplate}}"</span>?
          </p>
          <div class="task-card__cancel-actions">
            <div class="btn btn-sm action cancelation" @click="closeCancelTaskConfirmation">No</div>
            <div class="btn btn-sm action confirmation" @click="cancelTask">Sí, cancelar</div>
          </div>
        </div>
      </div>

    </div>
    <div class="async-task-card__results">
      <p class="process-steps"
        v-if="isProcessing">{{ stepLabel }}</p>
      <div class="async-task-card__progress progress"
        :class="{ completed: getProgressPercentage === HUNDRED_PERCENT && isAttachmentTask }"
        v-show="isProcessing"
      >
        <div class="progress-bar bg-info"
          :title="getProgressPercentage === HUNDRED_PERCENT ? 'Procesamiento de registros completado.' : ''"
          role="progressbar"
          :style="`width: ${getProgressPercentage}%`"
          :aria-valuenow="getProgressPercentage"
          aria-valuemin="0"
          :aria-valuemax="task.process.total"
        >
          <span v-if="getProgressPercentage === HUNDRED_PERCENT"><i class="fad fa-line-columns"></i> Completado</span>
          <span v-else><i class="fad fa-line-columns"></i> {{ getProgressPercentage }}%</span>
        </div>
      </div>
      <p class="remaining-time"
        v-show="isProcessing &&
          getProgressPercentage < HUNDRED_PERCENT"
      >{{ remainingTime ? `Quedan ${remainingTime}` : 'Calculando...' }}</p>
      <div class="async-task-card__attachment-progress progress"
        :class="{ completed: getAttachmentProgressPercentage === HUNDRED_PERCENT }"
        v-if="isProcessing && isAttachmentTaskInProgress"
      >
        <div class="progress-bar bg-secondary"
          :title="getAttachmentProgressPercentage === HUNDRED_PERCENT ? 'Procesamiento de archivos adjuntos completado.' : ''"
          role="progressbar"
          :style="`width: ${getAttachmentProgressPercentage}%`"
          :aria-valuenow="getAttachmentProgressPercentage"
          aria-valuemin="0"
          :aria-valuemax="getTaskProcess.attachmentProgress.total"
        >
          <span v-if="getAttachmentProgressPercentage === HUNDRED_PERCENT"><i class="fad fa-file-archive"></i> Completado</span>
          <span v-else><i class="fad fa-file-archive"></i> {{ getAttachmentProgressPercentage }}%</span>
        </div>
      </div>
      <p class="remaining-time"
        v-show="isProcessing && isAttachmentTaskInProgress &&
          this.getAttachmentProgressPercentage < this.HUNDRED_PERCENT"
      >{{ attachmentRemainingTime ? `Quedan ${attachmentRemainingTime}` : 'Calculando...' }}</p>
      <div v-show="isGettingTaskLink" class="async-task-card--getting-link">
        <span>Obteniendo enlace ... <i class="fas fa-cog fa-spin"></i></span>
      </div>
      <div class="async-task-card__download-link" v-show="getTaskProcess !== null && isDone">
        <a target="_blank" @click="redirectUrlResult" :title="task.name">
          {{ `Descargar archivo ${getTaskFormat}` }}
        </a>
      </div>
    </div>
    <div v-if="showExtraDetails" class="async-task-card__extra-details">
      <span class="span-close" @click="showExtraDetails = !showExtraDetails"><i class="fal fa-times"></i></span>
      <p v-if="getTaskProcess" class="async-task-card__request-id" ><span>Request ID: </span>{{ getTaskRequestId }}</p>
      <p v-if="getTaskError && getTaskError.code > 0" class="async-task-card__error"><span>Error: </span>{{ getTaskError.description }} </p>
    </div>
  </div>
</template>
<script lang="ts">
import { AsyncTask, AsyncTaskProcess, AsyncTaskStatus } from '@/types/catalogs/AsyncTask'
import CatalogsFillsService from '@/services/CatalogsFillsService'
import { BLUEError } from '@/types/Errors'
import { NUMBER } from '@/types/GeneralConstants'
import Vue, { PropType } from 'vue'

export default Vue.extend({
  props: {
    task: {
      type: Object as PropType<AsyncTask>,
      required: true
    },
    canRemoveTask: {
      type: Boolean,
      default: false
    },
    canCancelTask: {
      type: Boolean,
      default: false
    },
    remainingTime: {
      type: String
    },
    attachmentRemainingTime: {
      type: String
    }
  },
  data () {
    return {
      HUNDRED_PERCENT: NUMBER.ONE_HUNDRED as number,
      status: AsyncTaskStatus,
      hide: false,
      showExtraDetails: false,
      showCancelConfirmation: false
    }
  },
  computed: {
    getTaskId (): number {
      return this.task.id
    },
    getTaskTemplate (): string {
      return `${this.task.template.label} [v${this.task.template.version}]`
    },
    getTaskStatus (): string {
      return this.task.status
    },
    getTaskTypeTranslated (): string {
      return this.task.taskType()
    },
    getTaskProcess (): AsyncTaskProcess {
      return this.task.process
    },
    getTaskRequestId (): string {
      return this.getTaskProcess.requestId
    },
    getTaskCreationDate (): string {
      return this.task.getLocalCreationDate()
    },
    getTaskFormat (): string {
      return this.isAttachmentTask
        ? '.ZIP'
        : `.${this.getTaskProcess.format}`
    },
    getTaskError (): BLUEError {
      return this.getTaskProcess.error || new BLUEError(0, 'Sin descripción')
    },
    getProgressPercentage (): number {
      return parseInt(this.task.getPercentage().toFixed(0))
    },
    getAttachmentProgressPercentage (): number {
      return this.task.attachmentPercentage !== undefined
        ? parseInt(this.task.attachmentPercentage.toString())
        : 0
    },
    isNew (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.NEW)
    },
    isProcessing (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.PROCESSING)
    },
    isDone (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.DONE)
    },
    isError (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.ERROR)
    },
    isWaiting (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.WAITING)
    },
    isCanceled (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.CANCELED)
    },
    isAttachmentTask (): boolean {
      return this.getTaskProcess.attachmentProgress !== undefined
    },
    isAttachmentTaskInProgress (): boolean {
      return this.isAttachmentTask &&
        this.getTaskProcess.attachmentProgress?.total !== undefined &&
        this.getAttachmentProgressPercentage !== undefined
    },
    stepLabel (): string {
      const stepAmount = this.isAttachmentTask ? NUMBER.TWO : NUMBER.ONE
      let currentStep = NUMBER.ONE
      if (
        this.isProcessing &&
        this.isAttachmentTaskInProgress
      ) {
        currentStep = NUMBER.TWO
      } else if (this.isProcessing) {
        currentStep = NUMBER.ONE
      }
      return `Proceso ${currentStep} de ${stepAmount}`
    },
    isGettingTaskLink (): boolean {
      let gettingLink = [this.isProcessing, this.getProgressPercentage === this.HUNDRED_PERCENT]
      if (this.isAttachmentTask) {
        gettingLink.push(this.getAttachmentProgressPercentage === this.HUNDRED_PERCENT)
      }
      return gettingLink.every(Boolean)
    },
    isIntegrationCount (): boolean {
      return this.task.type === 'INTEGRATION' && (this.isProcessing || this.isDone)
    }
  },
  methods: {
    /** @returns true if the task has a determinated status */
    taskHasStatus (status: AsyncTaskStatus): boolean {
      return this.getTaskStatus === status
    },
    /** Emit the event to remove the task notification */
    hideTask () {
      this.hide = true
      setTimeout(() => {
        this.hide = false
        this.$emit('hide-task', this.getTaskStatus, this.getTaskId, this.task.type, this.task.updateDate)
      }, 350)
    },
    showCancelTaskConfirmation () {
      this.showCancelConfirmation = true
    },
    closeCancelTaskConfirmation () {
      this.showCancelConfirmation = false
    },
    cancelTask () {
      this.$emit('cancel-task', this.task.id)
    },
    async redirectUrlResult () {
      await CatalogsFillsService.getResultByID(this.task.id)
        .then(response => {
          const url:string = response.url
          window.location.href = url
        }).catch(() => {
          this.$bvToast.toast('Lo sentimos, ocurrió un error al descargar los resultados.', {
            title: 'Error de descarga',
            variant: 'danger',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 4500
          })
        })
    }
  }
})
</script>

<style lang="scss" scoped>
$new-task: var(--teal);
$processing-task: var(--cyan);
$done-task: var(--green);
$error-task: var(--red);
$waiting-task: var(--yellow);
$canceled-task: var(--gray);
$generic-card: var(--light);

.animate__fadeOutRight {
  --animate-duration: 0.35s;
}

@keyframes stepPulse {
  0% {
    background-color: var(--light);
  }
  50% {
    background-color: var(--secondary);
  }
  100% {
    background-color: var(--light);
  }
}

div.async-task-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 0.4rem 0.5rem 1rem;
  background-color: $generic-card;
  border-bottom: 2px solid #ccc;

  p {
    margin: 0;
  }

  &.new,
  &.processing,
  &.waiting {
    background-image: linear-gradient(to right, $processing-task 10px, $generic-card 10px);
  }
  &.done {
    background-image: linear-gradient(to right, $done-task 10px, $generic-card 10px);
  }
  &.error {
    background-image: linear-gradient(to right, $error-task 10px, $generic-card 10px);
  }
  &.canceled {
    background-image: linear-gradient(to right, $canceled-task 10px, $generic-card 10px);
  }

  .async-task-card__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 1.2rem;
    .async-task-card__close {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1.6rem;
      height: 1.6rem;
      font-size: 1.2rem;
      border-radius: 9rem;
      cursor: pointer;
    }
  }

  .async-task-card__id {
    display: inline-block;
    text-align: left;
    width: 100%;
  }
  .card__name-and-actions {
    display: flex;
    justify-content: space-between;
    margin: 0 0 0.25rem 0;
    width: 100%;

    .async-task-card__details {
      font-size: 0.875rem;

      .async-task-card__template {
        font-size: larger;
        font-weight: bold;
      }
      .async-task-card__creation {
        display: inline-block;
        font-size: small;
      }
      i.async-task-card__extras {
        display: inline-block;
        margin: 0 0 0 0.2rem;
        cursor: pointer;
      }
    }
    .async-task-card__cancel-btn {
      height: 2.4rem;
      background-color: transparent;
      color: var(--danger);
      transition-duration: 250ms;

      &:hover {
        background-color: var(--danger);
        color: var(--white);
      }
    }
    .async-task-card__confirm-deletion {
      margin: 0 0 0.25rem 0;
      width: 100%;
      border-radius: 4px;
      padding: 0.25rem 0.5rem;
      font-size: small;
      font-weight: 500;
      background-color: var(--element-hover-bg-color);

      .async-task-card__cancel-confirmation {
        text-align: center;
        height: fit-content;

        .task-card__cancel-question {
          text-align: left;
          margin: 0;
          span {
            font-style: italic;
          }
        }
        .task-card__cancel-actions {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          .action {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40%;
            height: 1.5rem;
            border-radius: 4px;
            transition-duration: 300ms;
            &.confirmation {
              border: solid 1px var(--danger);
              color: var(--danger);
              &:hover {
                background-color: var(--danger);
                color: var(--white);
              }
            }
            &.cancelation {
              &:hover {
                background-color: var(--gray);
                color: var(--white);
              }
            }
          }
        }
      }
    }
  }
  .async-task-card__results {
    position: relative;
    width: 100%;
    margin: 0 0 0.25rem 0;
    .process-steps {
      position: relative;
      line-height: 1;
      font-size: 0.75rem;
      opacity: 0.6;
    }
    .async-task-card__progress,
    .async-task-card__attachment-progress {
      height: 2rem;
      user-select: none;
      transition-duration: 300ms;
      &.completed {
        height: 1rem;
        span {
          transition-duration: 300ms;
          font-size: 0.6rem;
        }
        &:hover {
          height: 2rem;
          span {
            font-size: 0.8rem;
          }
        }
      }
      span {
        display: inline-block;
        font-size: 0.8rem;
      }
    }
    .async-task-card--getting-link {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 2rem;
      font-size: 0.9rem;
    }
    .async-task-card__download-link {
      cursor: pointer;
      a {
        display: inline-block;
        width: 100%;
        padding: 4px;
        font-weight: 500;
        text-decoration: none;
        text-align: center;
        border-radius: 4px;
        border: 1px solid var(--secondary);
        color: #525252;
        transition-duration: 200ms;
      }
      a:hover {
        border: 1px solid var(--primary);
        background-color: var(--primary);
        color: var(--white);
      }
    }
    .remaining-time {
      font-size: 0.75rem;
    }
  }
  .async-task-card__percentage {
    opacity: 0.5;
    pointer-events: none;
    grid-area: percentage;
    justify-self: end;
  }
  .async-task-card__extra-details {
    position: relative;
    grid-area: extra;
    width: 100%;
    border-radius: 4px;
    padding: 0.2rem;
    font-size: small;
    background-color: var(--element-hover-bg-color);

    .async-task-card__request-id {
      span {
        font-weight: 500;
      }
    }
    .async-task-card__error {
      span: {
        font-weight: 500;
      }
    }
    .span-close {
      position: absolute;
      display: inline-block;
      right: 0;
      margin: 0 0.5rem 0 0;
      cursor: pointer;
    }
  }
}

@media screen and (hover :hover) {
  .async-task-card__close:hover {
    text-align: center;
    background-color: var(--white);
  }
}
</style>
